<template>
  <div class="container">
    <!-- 轮播图 -->
    <div class="tops">
      <div class="bgg">
        <div class="swipeInfo">
          <div class="left">
            <div class="stit"> {{ $t('home').topTips }}</div>
            <div class="sbtn" v-if="showRegister" @click="$router.push({ name: 'Register' })"> {{ $t('register').btn }}
            </div>
            <div class="sbtn" v-else @click="$router.push({ name: 'Trade' })"> {{ $t('tabBar').trade }}</div>
          </div>
          <img src="@/assets/img/bg.webp" class="swimg" />
        </div>
        <div class="numInfo">
          <div class="item">
            <div class="num">$281.46{{ $t('home').hundredmillion }}</div>
            <div class="txt">{{ $t('home').transactionvolume }}</div>
          </div>
          <div class="item">
            <div class="num">$77.98{{ $t('home').hundredmillion }}</div>
            <div class="txt">{{ $t('home').openinterest }}</div>
          </div>
          <div class="item">
            <div class="num">200{{ $t('home').thousand }}</div>
            <div class="txt">{{ $t('home').RegisteredUser }}</div>
          </div>
          <div class="item">
            <div class="num">14{{ $t('home').year }}</div>
            <div class="txt">{{ $t('home').Ensuresafetyfunds }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="info">
      <!-- 标题 -->
      <div class="tit">{{ $t('home').Capturetrading }}</div>
      <!-- 产品列表 -->
      <div class="productInfo">
        <!-- 分类 -->
        <!-- 行情分类 -->
        <div class="proTab"><span v-for="(item, index) in tabsMarket" :key="`tabma${index}`"
            :class="activeMarket == item.value ? 'active' : ''" @click="changeMarketTab(item.value)">{{ item.name
            }}</span></div>
        <!-- 产品标题 -->
        <div class="title">
          <div class="name">{{ $t('market').product }}</div><span>{{ $t('market').Latestprice }}</span><span>{{
            $t('market').volume }}</span><span>{{ $t('market').ChangeRatio }}</span><span>{{ $t('tabBar').trade
            }}</span>
        </div>
        <!-- 添加自选 -->
        <div class="addSelectBtn" v-if="activeMarket == 0 && showAddSelect">
          <van-button block @click="$router.push({ name: 'MySelect', query: { i: true } })">{{ $t('market').Addoptional
          }}</van-button>
        </div>
        <!-- 产品列表 -->
        <div class="item" v-for="(item, index) in pList" :key="`pro${index}`"
          @click="$router.push({ name: 'Trade', query: { id: item.productId } })">
          <div class="name"> <img :src="baseUrl + item.logoUrl" />{{ item.name }} </div>
          <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.newPrice }}</span>
          <span>{{ item.volume | formatNumber }}</span>
          <span :class="item.priceChangeRatio > 0 ? 'green' : 'red'">{{ item.priceChangeRatio
          }}%</span>
          <span class="btn">{{ $t('tabBar').trade }}</span>
        </div>
        <div class="bombtn" @click="$router.push({ name: 'Market' })">{{ $t('property').Seemore }}</div>
      </div>
      <!-- 探索我们的产品 -->
      <div class="exploreInfo">
        <div class="title">{{ $t('home').Exploreproducts }}</div>
        <div class="twoInfo">
          <!-- 合约交易 -->
          <div class="item" @click="toTrade(1)">
            <div class="left">
              <div class="ltit">{{ $t('home').Contracttrading }}</div>
              <div class="txt">{{ $t('home').ContracttradingTips }}</div>
              <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
              </div>
            </div>
            <img class="eximg" src="@/assets/img/home_p_1.png" />
          </div>
          <!-- 现货交易 -->
          <div class="item" style="margin-left: 30px;" @click="toTrade(3)">
            <div class="left">
              <div class="ltit">{{ $t('home').coin }}</div>
              <div class="txt">{{ $t('home').coinTips }}</div>
              <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
              </div>
            </div>
            <img class="eximg" src="@/assets/img/home_p_2.png" />
          </div>
        </div>
        <div class="items">
          <!-- 理财 -->
          <div class="item" @click="$router.push({ name: 'Finance' })">
            <div class="lab">{{ $t('home').Spottrading }}</div>
            <div class="tips">{{ $t('home').SpottradingTips }}</div>
            <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
          <!-- C2C -->
          <div class="item" @click="$router.push({ name: 'C2c' })">
            <div class="lab">C2C</div>
            <div class="tips">{{ $t('common').c2cTips }}</div>
            <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
          <!-- 充值 -->
          <div class="item" @click="$goRecharge('RechargeCurrency')">
            <div class="lab">{{ $t('common').Depositcoins }}</div>
            <div class="tips">{{ $t('common').DepositcoinsTips }}</div>
            <div class="btns"> {{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
          <!-- 划转 -->
          <div class="item" @click="$router.push({ name: 'AssetTransfer' })">
            <div class="lab">{{ $t('asset').Transfer }}</div>
            <div class="tips">{{ $t('common').TransferTips }}</div>
            <div class="btns"> {{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
        </div>
      </div>
      <!-- 下载 -->
      <div class="downInfo">
        <div class="title">{{ $t('home').Tradeanytime }}</div>
        <div class="imginfo">
          <div class="left">
            <div class="codess">
              <div class="code">
                <div class="imgs"><qrcode-vue :value="qrcodeUrl" :size="130" level="H" class="qrimg"></qrcode-vue></div>
                <div class="lab">
                  <div class="t1">{{ $t('home').Scandownload }}</div>
                  <div class="t2">IOS & Android</div>
                </div>
              </div>
            </div>
            <div class="lables">
              <div class="item" @click="openTo(iosUrl)">
                <svg-icon class-name="svgs" icon-class="apple" />
                <div class="txt">App Store</div>
              </div>
              <div class="item" @click="openTo(androidUrl)">
                <svg-icon class-name="svgs" icon-class="googlepay" />
                <div class="txt">Google Pay</div>
              </div>
            </div>
          </div>
          <div class="right"><img src="@/assets/img/home_down.png" /></div>
        </div>
      </div>
      <!-- 选择我们的理由 -->
      <div class="reasonInfo">
        <!-- <video class="myVideo" autoplay muted playsinline loop>
          <source src="@/assets/img/home_us.mp4" type="video/mp4">
        </video> -->
        <div class="title">{{ $t('home').Reasonschoosingus }}</div>
        <div class="tips">Exchange for a better future</div>
        <div class="txtss"><span>{{ $t('home').mobeginwith }}2011</span><span>{{ $t('home').Topliquidity }}</span><span
            style="border-right: none;">{{ $t('home').Effectivelyusers }}</span></div>
        <div class="btns">
          <div class="btn" @click="toTrade()">{{ $t('home').TradeNow }}</div>
        </div>
      </div>
      <!-- 需要帮助 -->
      <!-- <div class="helpInfo">
        <div class="title">{{ $t('home').Needhelp }}？</div>
        <div class="items">
          <div class="item" @click="$router.push({ name: 'Help' })">
            <div class="lab">{{ $t('home').helpcenter }}</div>
            <div class="tips">{{ $t('home').helpcenterTips }}</div>
            <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
          <div class="item">
            <div class="lab">{{ $t('home').Onlinecustomerservice }}</div>
            <div class="tips">{{ $t('home').OnlinecustomerserviceTips }}</div>
            <div class="btns">{{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
          <div class="item" @click="$router.push({ name: 'Notice' })">
            <div class="lab">{{ $t('home').PlatformAnnouncement }}</div>
            <div class="tips">{{ $t('home').PlatformAnnouncementTips }}</div>
            <div class="btns"> {{ $t('home').Learnmore }}<van-icon name="arrow" size="15" color="var(--text_color)" />
            </div>
          </div>
        </div>
      </div> -->
    </div>
    <!-- 立即开启您的加密货币交易之旅！ -->
    <div class="startInfo">
      <div class="title">{{ $t('home').Starttradingnow }}</div>
      <div class="tips">{{ $t('home').Trademillions }}</div>
      <div class="btns">
        <div class="btn" @click="$goRecharge('RechargeCurrency')">{{ $t('home').Storingbuyingcoins }}</div>
      </div>
    </div>
    <!-- 取款选择 -->
    <van-popup v-model="showWithSelect" position="center" style="width: 400px;" closeable>
      <div class="withSelInfo">
        <div class="tit">{{ $t('common').Withdraw }}</div>
        <div class="tabs" @click="$router.push({ name: 'WithCurrency' })">{{ $t('common').Cryptocurrencywithdrawal }}
          <span><van-icon name="arrow" size="15" color="var(--ntext_color)" /></span>
        </div>
        <div class="tabs" @click="$router.push({ name: 'With' })">{{ $t('common').Fiatmoneywithdrawal }}<span><van-icon
              name="arrow" size="15" color="var(--ntext_color)" /></span></div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import productApi from '@/api/product'
import systemApi from '@/api/system'
import { webSocket } from "@/mixins/webSocket.js";
import QrcodeVue from 'qrcode.vue'
import { Token } from '@/utils/mm'
export default {
  name: 'Home',
  mixins: [webSocket],
  components: {
    QrcodeVue
  },
  data() {
    return {
      showRegister: true,
      //行情分类
      activeMarket: 1,
      showWithSelect: false,
      baseUrl: window.baseURL,
      showAddChat: false,
      pList: [],
      showAddSelect: false,
      qrcodeUrl: '',
      iosUrl: '',
      androidUrl: '',
    }
  },
  computed: {
    tabsMarket() {
      return [{
        name: this.$t('home').optional,
        value: 0
      }, {
        name: this.$t('home').HotList,
        value: 1
      }]
    },
  },
  watch: {},
  mounted() {
    window.scrollTo(0, 0);
    if (Token.get()) this.showRegister = false
    this.getConfig()
    this.getHomeHotList()
  },
  //销毁之前
  beforeDestroy() {
    this.websockClose();
  },
  methods: {
    // 获取配置
    async getConfig() {
      const res = await systemApi.getConfig()
      this.qrcodeUrl = res.systemSetting.qrcodeUrl
      this.iosUrl = res.systemSetting.iosUrl
      this.androidUrl = res.systemSetting.androidUrl
    },
    //跳转新窗口
    openTo(val) {
      window.open(val)
    },
    //跳转交易
    toTrade(val) {
      if (this.$route.name == 'Trade') return
      if (val)
        this.$router.push({ name: 'Trade', query: { type: val } })
      else
        this.$router.push({ name: 'Trade' })
    },
    //切换行情分类
    changeMarketTab(val) {
      this.activeMarket = val
      if (val == 0) this.getOptionalProductList()
      if (val == 1) this.getHomeHotList()
    },
    onBannerGo(val) {
      if (val.type == 1)
        this.$router.push({ path: val.path })
      else
        location.href = val.path
    },
    // 查询自选产品列表
    async getOptionalProductList() {
      if (!Token.get()) {
        this.pList = []
        return
      }
      var parms = {}
      parms.pageNum = 1
      parms.pageSize = 1000
      parms.productBusiness = '1'
      const res = await productApi.getOptionalProductList(parms)
      this.pList = res.rows.slice(0, 5);
      if (this.pList.length > 0)
        this.showAddSelect = false
      else this.showAddSelect = true
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    // 首页产品列表
    async getHomeHotList() {
      const res = await productApi.getHomeHotList()
      this.pList = res.rows.slice(0, 5);
      this.webSocketInit(() => {
        this.websocketGet()
      })
    },
    //推送
    websocketGet() {
      let that = this
      // 订阅产品给价格赋值
      const subRequest = {
        action: 'SubAdd',
        content: that.pList.map(item => item.symbol)
      };
      that.websockSend(JSON.stringify(subRequest), (reslult) => {
        // 产品列表
        that.pList.forEach((sItem) => {
          let quotes = reslult.find(item => item.Symbol == sItem.symbol);
          if (quotes) {
            sItem.newPrice = quotes.NewPrice
            sItem.volume = quotes.Volume
            sItem.priceChangeRatio = quotes.PriceChangeRatio
          }
        })
      })
    },
  }
}
</script>

<style lang="less" scoped>
.container {
  min-height: 100vh;
  padding-top: 56px;
  width: 100%;
  background: var(--background_color);

  .tops {
    background: #000000;

    .bgg {
      padding-top: 30px;
      margin: 0 auto;
      max-width: 1480px;
      background: #020202;
      // background-image: url(../../assets/img/home-banner-background.png);
      background-position: 100% 0;
      background-repeat: no-repeat;
      background-size: contain;

      .swipeInfo {
        margin: 0 auto;
        max-width: 1280px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          .stit {
            font-size: 60px;
            color: #fff;
            font-weight: 700;
            line-height: 72px;
          }

          .sbtn {
            margin-top: 50px;
            border-radius: 10px;
            background: #fff;
            width: 200px;
            height: 56px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 16px;
            color: #000000;

            &:hover {
              opacity: 0.8;
            }
          }
        }

        .swimg {
          width: 50%;
        }
      }

      .numInfo {
        padding: 50px 0;
        margin: 0 auto;
        max-width: 1062px;
        display: flex;
        justify-content: space-between;

        .item {
          border-radius: 20px;
          border: 1px solid #343434;
          background-color: #0a0a0a;
          text-align: center;
          width: 23%;
          padding: 20px;

          .num {
            font-size: 24px;
            font-weight: 700;
            color: #fff;
          }

          .txt {
            margin-top: 20px;
            font-size: 16px;
            color: #fff;
          }
        }
      }
    }
  }

  .info {
    margin: 0 auto;
    max-width: 1280px;

    .commonInfo {
      width: 100%;
      margin: 50px 0;
      display: flex;
      justify-content: space-between;

      .item {
        width: 19%;
        text-align: center;
        background: var(--info_color);
        padding: 30px 0;
        border-radius: 20px;

        .svgs {
          width: 50px;
          height: 50px;
          color: var(--text_color);
        }

        .txt {
          margin-top: 20px;
          font-size: 16px;
          color: var(--text_color);
        }
      }

      .item:hover {
        opacity: 0.8;
      }
    }

    .tit {
      margin-top: 100px;
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .productInfo {
      padding: 60px 0;

      .proTab {
        font-size: 20px;
        color: var(--ntext_color);

        span {
          margin-right: 40px;
        }

        .active {
          color: var(--text_color);
          padding-bottom: 10px;
          border-bottom: 2px solid var(--text_color);
        }
      }

      .title {
        margin-top: 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: var(--ntext_color);
        font-size: 14px;
        height: 50px;
        border-bottom: 1px solid var(--line_color);

        .name {
          width: 30%;
          text-align: left;
        }

        span {
          width: 14%;
          text-align: right;
        }
      }

      .addSelectBtn {
        margin: 20px 150px;

        .van-button {
          margin-top: 50px;
          background: var(--text_color);
          height: 50px;
          border-radius: 25px;
          border: 0;
          font-size: 16px;
          color: var(--background_color);
        }

        .van-button:hover {
          opacity: 0.8;
        }
      }

      .item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 10px;
        color: var(--text_color);
        font-size: 16px;
        border-bottom: 1px solid var(--line_color);

        .name {
          font-weight: bold;
          width: 30%;
          text-align: left;
          display: flex;
          align-items: center;

          img {
            width: 32px;
            height: 32px;
            border-radius: 50%;
            margin-right: 20px;
          }
        }

        span {
          width: 14%;
          text-align: right;
        }

        .btn {
          width: 60px;
          margin-left: 100px;
          height: 35px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 13px;
          color: var(--text_color);
          background: var(--background_color);
          border: 1px solid var(--text_color);
          border-radius: 20px;
        }

        .btn:hover {
          color: var(--background_color);
          background: var(--text_color);
        }

      }

      .item:hover {
        background: var(--info_color);
      }

      .bombtn {
        margin-top: 30px;
        text-align: right;
        font-size: 14px;
        color: var(--ntext_color);

        &:hover {
          color: var(--text_color);
          text-decoration: underline;
        }
      }
    }

    .exploreInfo {
      margin-top: 100px;

      .title {
        font-size: 48px;
        font-weight: bold;
        color: var(--text_color);
      }

      .twoInfo {
        margin-top: 50px;
        display: flex;
        justify-content: space-between;
        // align-items: center;

        .item {
          width: 50%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: var(--info_color);
          padding: 40px;
          border-radius: 16px;

          &:hover {
            .eximg {
              transform: scale(1.1);
              transition: transform .3s cubic-bezier(.25, .46, .45, .94);
            }
          }

          .left {
            .ltit {
              font-size: 32px;
              font-weight: bold;
              color: var(--text_color);
            }

            .txt {
              margin-top: 30px;
              font-size: 16px;
              line-height: 25px;
              color: var(--ntext_color);
            }

            .btns {
              margin-top: 80px;
              font-size: 14px;
              color: var(--text_color);

              &:hover {
                opacity: 0.8;
              }
            }
          }

          .eximg {
            margin-left: 50px;
            width: 150px;
            height: 150px;
          }
        }
      }

      .items {
        margin-right: -30px;
        margin-top: 30px;
        display: flex;

        .item {
          margin-right: 30px;
          width: 25%;
          background: var(--info_color);
          padding: 25px;
          border-radius: 16px;

          .lab {
            font-size: 24px;
            font-weight: bold;
            color: var(--text_color);
          }

          .tips {
            margin-top: 20px;
            font-size: 16px;
            line-height: 25px;
            height: 50px;
            color: var(--ntext_color);
          }

          .btns {
            margin-top: 40px;
            font-size: 14px;
            color: var(--text_color);
          }
        }

        .item:hover {
          opacity: 0.8;
        }
      }
    }

    .downInfo {
      margin-top: 150px;

      .title {
        font-size: 48px;
        font-weight: bold;
        color: var(--text_color);
      }

      .imginfo {
        margin-top: 50px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .left {
          .codess {
            display: flex;

            .code {
              display: flex;
              align-items: center;
              justify-content: space-between;
              margin-right: 50px;

              .imgs {
                width: 170px;
                height: 170px;
                padding: 10px;
                border-radius: 8px;
                background: var(--info_color);

                .qrimg {
                  width: 150px;
                  height: 150px;
                  padding: 10px;
                  background: #fff;
                  border-radius: 8px;
                }
              }

              .lab {
                margin-left: 20px;

                .t1 {
                  font-size: 16px;
                  color: var(--ntext_color);
                }

                .t2 {
                  margin-top: 10px;
                  font-size: 21px;
                  color: var(--text_color);
                  font-weight: bold;
                }
              }
            }
          }

          .lables {
            margin-top: 30px;
            display: flex;

            .item {
              margin-right: 30px;
              width: 120px;
              height: 120px;
              text-align: center;
              background: var(--info_color);
              border-radius: 8px;
              padding: 25px 0;

              .svgs {
                width: 32px;
                height: 32px;
                color: var(--text_color);
              }

              .txt {
                margin-top: 20px;
                font-size: 16px;
                color: var(--text_color);
              }
            }

            .item:hover {
              opacity: 0.8;
            }
          }
        }

        .right {
          img {
            width: 500px;
            height: 320px;
          }
        }
      }
    }

    .reasonInfo {
      margin-top: 150px;
      padding-bottom: 150px;
      text-align: center;

      .title {
        margin-top: 100px;
        font-size: 48px;
        font-weight: bold;
        color: var(--text_color);
      }

      .tips {
        margin-top: 20px;
        font-size: 20px;
        color: var(--ntext_color);
      }

      .txtss {
        margin-top: 50px;
        display: flex;

        span {
          width: 33%;
          font-size: 20px;
          color: var(--text_color);
          font-weight: bold;
          border-right: 2px solid var(--text_color);
        }
      }

      .btns {
        margin-top: 50px;
        display: flex;
        justify-content: center;

        .btn {
          font-size: 16px;
          color: var(--background_color);
          background: var(--text_color);
          width: 160px;
          height: 50px;
          border-radius: 25px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .btn:hover {
          opacity: 0.8;
        }
      }



    }

    .helpInfo {
      margin-top: 200px;

      .title {
        font-size: 48px;
        font-weight: bold;
        color: var(--text_color);
      }

      .items {
        margin-top: 50px;
        display: flex;

        .item {
          margin-right: 20px;
          width: 33%;
          background: var(--info_color);
          padding: 40px;
          border-radius: 16px;

          .lab {
            font-size: 28px;
            color: var(--text_color);
          }

          .tips {
            margin-top: 20px;
            font-size: 16px;
            line-height: 25px;
            color: var(--ntext_color);
          }

          .btns {
            margin-top: 40px;
            font-size: 14px;
            color: var(--text_color);
          }
        }

        .item:hover {
          opacity: 0.8;
        }
      }
    }
  }

  .startInfo {
    padding-top: 150px;
    text-align: center;
    background: linear-gradient(180deg, var(--color-linearStart) 0, var(--background_color) 100%);

    .title {
      font-size: 48px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tips {
      margin-top: 20px;
      font-size: 20px;
      color: var(--ntext_color);
    }

    .txtss {
      margin-top: 50px;
      display: flex;

      span {
        width: 33%;
        font-size: 20px;
        color: var(--text_color);
        font-weight: bold;
        border-right: 2px solid var(--text_color);
      }
    }

    .btns {
      margin-top: 50px;
      display: flex;
      justify-content: center;

      .btn {
        font-size: 16px;
        color: var(--background_color);
        background: var(--text_color);
        width: 160px;
        height: 50px;
        border-radius: 25px;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .btn:hover {
        opacity: 0.8;
      }
    }
  }

  .withSelInfo {
    padding: 20px;

    .tit {
      margin-bottom: 30px;
      text-align: center;
      font-size: 21px;
      font-weight: bold;
      color: var(--text_color);
    }

    .tabs {
      margin-bottom: 20px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      font-size: 16px;
      font-weight: bold;
      color: var(--text_color);
      background: var(--info_color);
      border-radius: 10px;
      padding: 20px;
    }

    .tabs:hover {
      opacity: 0.8;
    }
  }

}

::v-deep .van-search__content {
  background-color: var(--info_color);
}

::v-deep .van-cell {
  color: var(--text_color);
}

::v-deep .van-field__control {
  color: var(--text_color);
}

::v-deep .van-popup--center {
  border-radius: 15px;
  background: var(--background_color);
}

::v-deep .van-popup__close-icon {
  font-size: 18px;
  color: var(--ntext_color);
}
</style>
